<template>
  <div class="addr-update">
    <!-- 修改寄回地址弹出框 -->
    <el-dialog
      title="修改寄回地址"
      :visible.sync="dialogVisible"
      width="30%"
      center
      custom-class="custom-addr-dialog"
      @close="$emit('update:visible', false)"
    >
      <el-form :model="sendModel" ref="sendForm" label-width="100px" size="small">
        <el-form-item label="寄回姓名:" prop="receiverName">
          <el-input v-model="sendModel.receiverName"></el-input>
        </el-form-item>
        <el-form-item label="寄回电话:" prop="receiverPhone">
          <el-input v-model="sendModel.receiverPhone"></el-input>
        </el-form-item>
        <el-form-item label="寄回地址:" prop="receiverProvince">
          <el-cascader
            v-model="selectedOptions"
            :options="options"
            placeholder="省/市/区"
            @change="addressChoose"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址:" prop="receiverDetailAddr">
          <el-input v-model="sendModel.receiverDetailAddr" type="textarea" rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogConfirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 省市区
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
// 修改订单
import { updateOrder } from "@/api/order.js";
export default {
  name: "AddressUpdate",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 订单对象
    myOrder: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      sendModel: {},
      // 保存地区级联选择器已选择的数据
      selectedOptions: [],
      options: regionData
    };
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue;
      this.sendModel = this.myOrder;
      console.log("this", this.myOrder);
      let arr = [];
      arr.push(TextToCode[this.sendModel.receiverProvince].code);
      arr.push(
        TextToCode[this.sendModel.receiverProvince][this.sendModel.receiverCity]
          .code
      );
      arr.push(
        TextToCode[this.sendModel.receiverProvince][
          this.sendModel.receiverCity
        ][this.sendModel.receiverRegion].code
      );
      this.selectedOptions = arr;
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 确定按钮
    handleDialogConfirm() {
      let data = JSON.parse(JSON.stringify(this.sendModel));
      //订单修改寄回地址
      updateOrder(data)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success("修改寄回地址成功！");
            // 完成后，触发一个事件通知父组件刷新数据
            this.$emit("refreshList", data);
          }
        })
        .catch(err => {});
    },
    // 地区三级级选择器
    addressChoose(value) {
      //我们选择地址后，selectedOptions 会保存对应的区域码，例如北京的区域码为'110000'
      //我们要取出区域码对应的汉字，就需要用CodeToText(区域码)进行输出
      this.sendModel.receiverProvince = CodeToText[value[0]];
      this.sendModel.receiverCity = CodeToText[value[1]];
      this.sendModel.receiverRegion = CodeToText[value[2]];
    }
  }
};
</script>

<style scoped lang="less">
.addr-update {
  /deep/ .custom-addr-dialog {
    height: 370px !important;
    margin-top: 100px !important;
    .el-dialog__body {
      padding: 10px 25px 0;
      .el-input__inner {
        width: 260px;
      }
      .el-textarea__inner {
        width: 260px;
      }
    }
  }
}
</style>
